import React from 'react'; 
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import CombosTable from '../../components/hall/combosTable/CombosTable';
import Conferences from '../../components/hall/conferences/Conferences';
import ConferenceView from '../../components/hall/conferences/view/ConferenceView';
import Hall from '../../components/hall/Hall';
import HallWithStands from '../../components/hall/stands/HallWithStands';
import StandView from '../../components/hall/standView/StandView';
import UserCombos from '../../components/stands/combos/UserCombos';

const User = () => {

  const { path } = useRouteMatch();
  const [comboTriggered, setComboTriggered] = React.useState({});

  return (
    <>
      <Switch>
        <Route path={`${path}`} component={Hall} exact/>
        <Route path='/userCombos' component={UserCombos}/>
        <Route path='/conferences/:id'component={ConferenceView}/>
        <Route path='/conferences'component={Conferences}/>
        <Route path={`${path}:hall/:id/combos`}> 
          <CombosTable comboTriggered={comboTriggered}/>
        </Route>
        <Route path={`${path}:hall/:id`} >
          <StandView setComboTriggered={setComboTriggered}/> 
        </Route>
        <Route path={`${path}:hall`} component={HallWithStands}/>
      </Switch>   
    </>
  );
};

export default User;